import { Injectable, Inject } from "@angular/core";
import { APP_CONFIG, IAppConfig } from "../app.config";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpRequest,
} from "@angular/common/http";
import Swal from "sweetalert2";
import { title } from "process";
import { Router } from "@angular/router";
import { catchError, map } from "rxjs/operators";
import { throwError } from "rxjs";
import { WINDOW } from "../window.providers";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
@Injectable({
  providedIn: "root",
})
export class GlobalService {
  responsedata: Response;
  videoTranscription: Boolean = true;
  response: Object;
  responsegetAll: Object;
  request: HttpRequest<any>;
  public loginType: string;
  method: any;
  hostName: string;
  hostcheck: string = "localhost";
  portName: any;
  constructor(
    @Inject(APP_CONFIG) private config: IAppConfig,
    private http: HttpClient,
    private router: Router,
    private spinner: NgxSpinnerService,
    @Inject(WINDOW) private window: Window
  ) {
    this.hostName = this.window.location.hostname;
    this.portName = this.window.location.port;
    if (this.portName == 4200) {
      this.config.apiPoint = this.config.LiveApiPoint;
      this.config.apiPointHealth = this.config.LiveApiPointHealth;
    } else if (this.portName == 85) {
      this.config.apiPoint = this.config.LocalApiPoint;
      this.config.apiPointHealth = this.config.LocalApiPointHealth;
    }
  }
  addFilter(filters) {
    let requestFilter = "";
    Object.keys(filters).map((key) => {
      if (
        filters[key] != undefined &&
        filters[key] != "" &&
        filters[key] != null
      ) {
        requestFilter = requestFilter + "&" + key + "=" + filters[key];
      }
    });

    return requestFilter;
  }
  healthcheckup(url, inputData) {
    return this.http
      .post(`${this.config.apiPointHealth}${url}`, inputData, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          token:
            "U2FsdGVkX180w8VxGlK0SuMmr9ozmmk2ooe6ME7zIAEImaJSvH5LmmC1NtJU/cjJWYtPkOdmJ6ohFH+91mYvfg==",
        }),
        observe: "response",
      })
      .pipe(
        map((value) => {
          const member: any = value.body;
          return member;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(err.error.message);
        })
      );
  }

  async create(url, inputData, isDiffPoint?) {
    inputData["requester_type"] = "web";

    await this.callAPI("POST", url, inputData, isDiffPoint, false).then(
      async (reason) => {
        if (reason["status"] === 200 || reason["status"] === 422) {
          this.responsedata = reason;
        } else {
          this.responsedata = reason;
        }
      }
    );
    return await this.responsedata;
  }

  async get(url, filter, showError?) {
    filter["requester_type"] = "web";
    let requestFilter = this.addFilter(filter);
    await this.callAPI("GET", url, requestFilter, false, showError).then(
      async (reason) => {
        if (reason) {
          if (reason["status"] === 200 || reason["status"] === 422) {
            this.response = reason;
          } else {
            this.response = reason;
          }
        } else {
          this.spinner.hide();
        }
      }
    );

    return this.response;
  }

  async update(url, inputData, showError?) {
    inputData["requester_type"] = "web";
    await this.callAPI("PUT", url, inputData, false, showError).then(
      async (reason) => {
        if (reason && (reason["status"] === 200 || reason["status"] === 422)) {
          this.response = reason;
        } else {
          this.response = reason;
        }
      }
    );
    return await this.response;
  }

  async delete(url, filter) {
    filter["requester_type"] = "web";
    let requestFilter = this.addFilter(filter);
    await this.callAPI("Delete", url, requestFilter, false, false).then(
      async (reason) => {
        if (reason["status"] === 200 || reason["status"] === 422) {
          this.response = reason;
        } else {
          this.response = reason;
        }
      }
    );
    return await this.response;
  }

  async callAPI(method, url, param, isDiffPoint?, showError?) {
    let pointV2 = this.config.apiPoint;
    if (isDiffPoint) {
      pointV2 = this.config.apiPoint.replace("/v1/", "/v2/");
    }
    try {
      if (method === "POST") {
        this.method = await this.http
          .post(`${pointV2}${url}`, param)
          .toPromise();
      } else if (method === "GET") {
        this.method = await this.http
          .get(`${this.config.apiPoint}${url}?${param}`)
          .toPromise();
      } else if (method === "PUT") {
        this.method = await this.http
          .put(`${this.config.apiPoint}${url}`, param)
          .toPromise();
      } else {
        this.method = await this.http
          .delete(`${this.config.apiPoint}${url}?${param}`)
          .toPromise();
      }

      if (this.method.status === 200) {
        return await this.method;
      }
    } catch (error) {
      if (!showError) {
        if (error.error.status == 400) {
          Swal.fire("Warning!", error.error.message, "warning");
        } else if (error.error.status == 401) {
          window.location.reload();
          Swal.fire("Warning!", error.error.message, "warning");
          this.router.navigateByUrl("/");
        } else if (error.error.status == 500) {
          Swal.fire("Error!", error.error.message, "error");
        } else if (error.error.status == 404) {
          Swal.fire("Warning!", error.error.message, "warning");
        } else if (error.error.status == 403) {
          Swal.fire("Warning!", error.error.message, "warning");
          // this.router.navigateByUrl("/dashboard");
        } else if (error.error.status == 422) {
          console.info("Error! ", error.error.message);
        } else {
          Swal.fire("Error!", error.error.message, "error");
        }

        return await error;
      }
      return await error;
    }
  }

  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    var UTCDate = moment.utc(dateValue + " " + timeValue);
    if (isDateRequested) {
      return UTCDate.format("YYYY-MM-DD");
    } else {
      return UTCDate.toDate();
    }
  }
}
